// Lógica compartilhada sobre análise cadastral, derivada do embed `analise_cadastral` da
// negociação. Relocado de views/CRM/Kanban/kanbanWork.ts (que reexporta esta função) para
// ser consumido também por fora do Kanban (ex.: Analytics Comercial) sem import cruzado.
import { Negociacao } from '../../types';
import { embedToArray } from './utils';

/** Decisão da análise cadastral mais recente (por decisao_final_at quando houver). */
export const ultimaDecisaoAnalise = (n: Negociacao): string | null => {
    // embedToArray: o embed vem como objeto (1→1) desde a UNIQUE em negociacao_id
    const analises = embedToArray(n.analise_cadastral);
    if (analises.length === 0) return null;
    const ordenadas = [...analises].sort((a, b) => {
        const ta = a.decisao_final_at ? new Date(a.decisao_final_at).getTime() : 0;
        const tb = b.decisao_final_at ? new Date(b.decisao_final_at).getTime() : 0;
        return tb - ta;
    });
    return ordenadas[0]?.decisao_final || null;
};

/** Pendência Documental = última análise cadastral com decisao_final = 'Pendência Documental'. */
export const isPendenciaDocumental = (n: Negociacao): boolean =>
    ultimaDecisaoAnalise(n) === 'Pendência Documental';
